module.exports = __webpack_public_path__ + "assets/samsung-black.766348c8.svg";